import React from 'react';
import nl2br from './nl2br';

export const URL_REGEX = /((http|ftp|https):\/\/w{3}[\d]*\.|(http|ftp|https):\/\/|w{3}[\d]*\.)([\w\d\._\-#\(\)\[\]\\,;:]+@[\w\d\._\-#\(\)\[\]\\,;:])?([a-z0-9가-힣]+\.)*[a-z가-힣\-0-9]+\.([a-z]{2,3})?[a-z]{2,6}(:[0-9]+)?(\/[\/a-z0-9가-힣\._\-,]+)*[a-z0-9가-힣\-_\.%]+(\?[a-z0-9가-힣=%&amp;\.\-,#]+)?|[a-z0-9]+:\/\/\S+/gim;

export function hasUrlString(str) {
  if (!str) return false;

  const result = str.match(URL_REGEX);
  return !!(result && (result.length > 0));
}

export function getUrlString(str) {
  if (!str) return false;
  const result = str.match(URL_REGEX);
  return !result ? [] : result;
}

export function linkify(contents) {
  return contents.map((e, idx) => {
    const t = e.get('t');
    const v = e.get('v');
    if (t === 'link') {
      const url = (v.startsWith('http://') || v.startsWith('https://')) ? v : `http://${v}`;
      return (
        <a href={url}
          target="_blank" className="link_url" key={idx}
        >
          {nl2br(e.get('v'))}
        </a>
      );
    }
    return (<span key={idx}>{nl2br(v)}</span>);
  });
}



// WEBPACK FOOTER //
// ./src/utils/urlUtil.js